module.exports = __webpack_public_path__ + "r-v3/img/set_chat.378b21a6.svg";